import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconFilterVectorProps extends SVGProps<any> {}
export class SVGIconFilterVector extends Component<SVGIconFilterVectorProps> {
  render() {
    const { width = 40, height = 40, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-filter-vector"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          d="M40 2C40 3.1 39.25 4 38.3333 4H1.66667C0.75 4 0 3.1 0 2C0 0.9 0.75 0 1.66667 0H38.3333C39.25 0 40 0.9 40 2ZM25 36H15C14.0833 36 13.3333 36.9 13.3333 38C13.3333 39.1 14.0833 40 15 40H25C25.9167 40 26.6667 39.1 26.6667 38C26.6667 36.9 25.9167 36 25 36ZM31.6667 18H8.33333C7.41667 18 6.66667 18.9 6.66667 20C6.66667 21.1 7.41667 22 8.33333 22H31.6667C32.5833 22 33.3333 21.1 33.3333 20C33.3333 18.9 32.5833 18 31.6667 18Z"
          fill="#513389"
        />
      </SVG>
    );
  }
}
